<template>
  <div class="renwu">
    <!-- 预约计划控制 -->
    <div class="top">
      <DatePicker @on-change="searchDateChange" v-model="searchDate" format="yyyy-MM-dd" separator=" 至 " type="daterange" placeholder="请选择筛选条件"></DatePicker>
      <Button class="title-btn fourSize" type="success" @click="toAddPlan" ghost>新增计划</Button>
    </div>
    <div class="table-cont">
      <Table row-key="id" :row-class-name="planRowClassName" :columns="planCols" :data="planData" border>
        <template slot-scope="{ row}" slot="action">
          <Button type="info" size="small" v-if="row.isPlan" style="margin-right: 5px" @click="editPlan(row)">修改</Button>

          <Button type="error" size="small" v-if="row.isPlan" @click="deletePlan(row)">删除</Button>
        </template>
      </Table>
    </div>
    <Modal class="ivumodal" footer-hide width="800" v-model="singleAdd" :title="planForm.title || '新增计划'">
      <div>
        <Form :model="planForm" :label-width="130" class="planForm">
          <FormItem label="计划日期">
            <DatePicker :disabled="planForm.planDateDisabled" class="planFormInput" format="yyyy-MM-dd" separator=" 至 " v-model="planForm.planDate" type="daterange" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem :label="item.label" v-for="(item, index) in planTimeArr" :key="item.id">
            <Input @on-blur="planNumChange(item.id, index)" class="planFormInput" v-model="item.peopleNum" placeholder=""></Input>
            <Button type="info" size="small" @click="openReservationModal(item.id, index)">团体任务<Icon type="md-add"></Icon></Button>
            <div style="margin-top: 10px" v-for="(childItem, childIndex) in item.children" :key="childItem.id">
              <div style="width: auto; display: flex; vertical-align: top">
                <Input class="planFormInput" readonly v-model="childItem.reservationName" placeholder=""></Input>

                <!--  <div style="margin-left: 10px;"> -->
                <Input class="planFormInput" @on-blur="planNumChange(item.id, index)" v-model="childItem.peopleNum" placeholder="预约人数"></Input>
                <div style="width: 80px">余量:<span class="yuliang">{{childItem.num ? childItem.num : childItem.peopleNum}}</span></div>
                <Button v-if="childItem.num == childItem.peopleNum" @click="deletePlanFormAppend(item.id, index, childIndex)" type="info">删除</Button>
              </div>
              <!-- </Input> slot="append" -->
              <!-- </div> -->
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="singleAdd = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="saveSingleData">保存</Button>
      </div>
      <Spin size="large" fix v-if="modelLoading"></Spin>
    </Modal>

    <Modal class="ivumodal" footer-hide width="300" v-model="reservationModal.open" draggable title="请录入团体任务Id">
      <div>
        <Input class="planFormInput" v-model="reservationModal.input" placeholder=""></Input>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="reservationModal.open = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="addPlanFormAppend">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  deleteBookingTimePlan,
  deleteBookingTimePlanOrg,
  getBookingTimePlan,
  getReservationByDate,
  getReservationInfoById,
  saveBookingTimePlan,
  selectBookingTime,
  updateBookingTimePlanOrgByFdisable,
} from "../servers/api";

export default {
  name: "jihua",
  data() {
    return {
      singleAdd: false,
      reservationModal: {
        open: false,
        input: "",
        timeId: undefined,
        timeIndex: undefined,
      },
      searchDate: "",
      planForm: { title: "", planDate: "" },
      planTimeArr: [],
      allBookingTime: [],
      allOrgReservation: [],
      planCols: [],
      planData: [],
      modelLoading: false,
      idArray: [],
    };
  },
  methods: {
    saveSingleData() {
      if (this.planForm.planDate) {
        let empty = false;
        this.planTimeArr.forEach((item) => {
          if (isNaN(item.peopleNum)) {
            empty = true;
            return false;
          }
          if (item.children) {
            item.children.forEach((child) => {
              if (isNaN(child.peopleNum)) {
                empty = true;
                return false;
              }
            });
            // item.children.forEach(child => {
            //   if (isNaN(child.peopleNum) || !child.reservationId) {
            //     empty = true
            //     return false
            //   } else {
            //     let reservationInfo = this.allOrgReservation.find(item => item.idOrgReservation === child.reservationId)
            //     if (reservationInfo) {
            //       child.reservationName = reservationInfo.orgName
            //     } else {
            //       this.$Message.error(item.label + '所选团体不存在，请确认')
            //       empty =true
            //     }
            //   }
            // })
          }
        });
        if (empty) {
          this.$Message.error("请将信息录入完整");
        } else {
          let planDateStrArr = [];
          let submitForm = {};
          this.planForm.planDate.forEach((item) => {
            let date = new Date(item);
            planDateStrArr.push(
              date.getFullYear() +
                "-" +
                (date.getMonth() + 1) +
                "-" +
                date.getDate()
            );
          });
          submitForm.planDateStart = planDateStrArr[0];
          submitForm.planDateEnd = planDateStrArr[1];
          submitForm.planTimeList = JSON.stringify(this.planTimeArr);
          this.modelLoading = true;
          saveBookingTimePlan(submitForm)
            .then(() => {
              this.$Message.success("保存成功");
              this.singleAdd = false;
              this.searchDateChange();
            })
            .finally(() => {
              this.modelLoading = false;
            });
        }
      } else {
        this.$Message.error("请选择计划日期");
      }
    },
    editPlan(rowData) {
      this.planForm = {};
      let bookingTimeArr = [];
      this.allBookingTime.forEach((item) => {
        let dataKey = "data_time_" + item.id;
        let timeData = rowData[dataKey];
        timeData = timeData || {
          id: undefined,
          peopleNum: 0,
          bookingPlanOrgList: [],
        };
        bookingTimeArr.push({
          id: item.id,
          planId: timeData.id,
          label: item.startTime + "-" + item.endTime,
          peopleNum: timeData.peopleNum,
          children: timeData.bookingPlanOrgList,
          num: timeData.num,
        });
      });
      this.planForm.planDate = [rowData.planDate, rowData.planDate];
      // this.selectReservationArr()
      this.planForm.planDateDisabled = true;
      this.planTimeArr = bookingTimeArr;
      this.singleAdd = true;
    },
    toAddPlan() {
      this.planForm = {};
      let bookingTimeArr = [];
      this.allBookingTime.forEach((item) => {
        bookingTimeArr.push({
          id: item.id,
          label: item.startTime + "-" + item.endTime,
          peopleNum: 0,
        });
      });
      this.planTimeArr = bookingTimeArr;
      this.singleAdd = true;
    },
    planRowClassName(row, index) {
      return "table-warning-row";
    },
    initTimeReservation(allOreservationArr) {
      this.planTimeArr.forEach((item, index) => {
        let needChange = false;
        if (item.children && item.children.length) {
          item.children.forEach((childItem) => {
            if (
              allOreservationArr.filter(
                (item) => item.idOrgReservation === childItem.reservationId
              ).length < 1
            ) {
              item.idOrgReservation = "";
              needChange = true;
            }
          });
        }
        if (needChange) {
          this.planTimeArr.splice(index, 1, item);
        }
      });
    },
    selectReservationArr() {
      if (!this.planForm.planDate) {
        this.allOrgReservation = [];
        this.initTimeReservation([]);
        return false;
      }
      let planDateStrArr = [];
      let submitForm = {};
      this.planForm.planDate.forEach((item) => {
        let date = new Date(item);
        planDateStrArr.push(
          date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate()
        );
      });
      submitForm.planDateStart = planDateStrArr[0];
      submitForm.planDateEnd = planDateStrArr[1];
      this.modelLoading = true;
      getReservationByDate(submitForm)
        .then((response) => {
          this.allOrgReservation = response.data.data;
          this.initTimeReservation(this.allOrgReservation || []);
        })
        .finally(() => {
          this.modelLoading = false;
        });
    },
    openReservationModal(timeId, timeIndex) {
      this.reservationModal.input = "";
      this.reservationModal.timeId = timeId;
      this.reservationModal.timeIndex = timeIndex;
      // this.reservationModal.open = true
      this.$Modal.confirm({
        render: (h) => {
          return h("Input", {
            props: {
              value: this.value,
              autofocus: true,
              placeholder: "请录入团体任务ID",
            },
            on: {
              input: (val) => {
                this.reservationModal.input = val;
              },
            },
          });
        },
        onOk: () => {
          if (this.reservationModal.input) {
            this.modelLoading = true;
            getReservationInfoById({
              reservationId: this.reservationModal.input,
            })
              .then((response) => {
                if (response.data.data) {
                  let {
                    data: { data: data },
                  } = response;
                  let timeInArr = this.planTimeArr.find(
                    (item) => item.id === timeId
                  );
                  if (timeInArr) {
                    if (timeInArr.children && timeInArr.children.length) {
                      timeInArr.children.push({
                        reservationId: data.idOrgReservation,
                        reservationName: data.orgName,
                        peopleNum: undefined,
                        id: "timeId_" + timeInArr.children.length,
                      });
                    } else {
                      timeInArr.children = [
                        {
                          reservationId: data.idOrgReservation,
                          reservationName: data.orgName,
                          peopleNum: undefined,
                          id: "timeId_0",
                        },
                      ];
                    }
                    this.planTimeArr.splice(timeIndex, 1, timeInArr);
                  }
                } else {
                  this.$Message.error("未查询到相关的体检预定任务");
                }
              })
              .finally(() => {
                this.modelLoading = false;
              });
          }
        },
      });
    },
    addPlanFormAppend() {
      console.log(this.reservationModal);
      // if (!this.planForm.planDate) {
      //   this.$Message.error('请先选择计划日期')
      //   return false
      // }
      // if (this.allOrgReservation.length < 1) {
      //   this.$Message.error('当前日期范围内没有预定的团体任务')
      //   return false
      // }
      // let timeInArr = this.planTimeArr.find(item => item.id === timeId)
      // if (timeInArr) {
      //   if (timeInArr.children && timeInArr.children.length) {
      //     timeInArr.children.push({reservationId: '', peopleNum: undefined, id: 'timeId_'+timeInArr.children.length})
      //   } else {
      //     timeInArr.children = [{reservationId: '', peopleNum: undefined, id: 'timeId_0'}]
      //   }
      //   this.planTimeArr.splice(timeIndex,1,timeInArr)
      // }
    },
    deletePlanFormAppend(timeId, timeIndex, childIndex) {
      let timeInArr = this.planTimeArr.find((item) => item.id === timeId);
      if (timeInArr && timeInArr.children && timeInArr.children.length) {
        if (timeInArr.children.length > 1) {
          timeInArr.children.splice(childIndex, 1);
        } else {
          timeInArr.children = [];
        }
      }
      this.planTimeArr.splice(timeIndex, 1, timeInArr);
    },
    planNumChange(timeId, timeIndex) {
      let timeInArr = this.planTimeArr.find((item) => item.id === timeId);
      if (timeInArr) {
        if (timeInArr.children && timeInArr.children.length) {
          let planNum = parseInt(timeInArr.peopleNum);
          let orgTotalNum = 0;
          timeInArr.children.forEach((child) => {
            orgTotalNum += parseInt(child.peopleNum || 0);
          });
          if (orgTotalNum > planNum) {
            this.$Message.error("计划人数小于团体总人数，已自动修正");
            timeInArr.peopleNum = orgTotalNum;
            this.planTimeArr.splice(timeIndex, 1, timeInArr);
          }
        }
      }
    },
    deletePlan(rowData) {
      this.$Modal.confirm({
        title: "提醒",
        content: "<p>确认要删除么</p>",
        onOk: () => {
          if (rowData.isPlan) {
            deleteBookingTimePlan({ id: rowData.id }).then(() => {
              this.planData = this.planData.filter(
                (item) => item.id !== rowData.id
              );
            });
          } else {
            deleteBookingTimePlanOrg({
              planId: rowData.planId,
              reservationId: rowData.reservationId,
            }).then(() => {
              let dataInArr = this.planData.find(
                (item) => item.id.indexOf(rowData.planId) >= 0
              );
              if (dataInArr) {
                let dataOrgInArr = dataInArr.children.find(
                  (item) => item.id === rowData.id
                );
                for (let jsonKey in dataInArr) {
                  if (
                    dataInArr[jsonKey].bookingPlanOrgList &&
                    dataInArr[jsonKey].bookingPlanOrgList.length
                  ) {
                    dataInArr[jsonKey].bookingPlanOrgList = dataInArr[
                      jsonKey
                    ].bookingPlanOrgList.filter(
                      (item) => item.reservationId !== rowData.reservationId
                    );
                  }
                }
                dataInArr.children = dataInArr.children.filter(
                  (item) => item.id !== rowData.id
                );
                this.planData.splice(dataInArr._index, 1, dataInArr);
              }
            });
          }
        },
        onCancel: () => {
          this.$Message.info("您取消了删除操作");
        },
      });
    },
    searchDateChange() {
      let submitForm = {};
      if (this.searchDate && this.searchDate.length && this.searchDate[0]) {
        let planDateStrArr = [];
        this.searchDate.forEach((item) => {
          let date = new Date(item);
          planDateStrArr.push(
            date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
          );
        });
        submitForm.planDateStart = planDateStrArr[0];
        submitForm.planDateEnd = planDateStrArr[1];
      }
      getBookingTimePlan(submitForm).then((response) => {
        this.planData = response.data.data;
      });
    },
    switchChange(e, value) {
      console.log(e.organizationId, e.planDate, value);
      let disable = value ? 0 : 1;
      updateBookingTimePlanOrgByFdisable({
        organizationId: e.organizationId,
        planDate: e.planDate,
        disable: disable,
      }).then((res) => {
        if (res.data.code === 1) {
          if (value) {
            this.$Message.success("已打开预约");
          } else {
            this.$Message.success("已禁用预约");
          }
        }
      });
    },
  },
  mounted() {
    selectBookingTime({}).then((response) => {
      if (response.data.code === 1) {
        this.allBookingTime = response.data.data;
        this.allBookingTime.forEach((item) => {
          this.idArray.push(item.id);
        });
        this.planCols = [
          {
            title: "日期",
            key: "showName",
            width: 220,
            tree: true,
            render: (h, params) => {
              return h("span", [
                h(
                  "span",
                  {
                    style: {
                      marginRight: "5px",
                    },
                  },
                  params.row.showName
                ),
                h("i-switch", {
                  //数据库1是已处理，0是未处理
                  props: {
                    type: "primary",
                    trueColor: "#53cac3",
                    value: params.row.disable === 0, //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.children ? "inline-block" : "none",
                  },
                  on: {
                    "on-change": (value) => {
                      //触发事件是on-change,用双引号括起来，
                      //参数value是回调值，并没有使用到
                      this.switchChange(params.row, value); //params.index是拿到table的行序列，可以取到对应的表格值
                    },
                  },
                }),
              ]);
            },
          },
        ];
        this.allBookingTime.forEach((item) => {
          this.planCols.push({
            title: item.startTime + "-" + item.endTime,
            width: 130,
            key: "time_" + item.id,
          });

          /*  this.planCols.push({ title: "余量", width: 80, key: "num" }); */
        });
        this.planCols.push({
          title: "任务ID",
          width: 80,
          key: "reservationId",
        });
        this.planCols.push({ title: "小计", width: 80, key: "totalNum" });

        this.planCols.push({
          title: " ",
          slot: "action",
          width: 150,
          align: "right",
        });
        getBookingTimePlan({}).then((response) => {
          this.planData = response.data.data;
          /*let array = response.data.data;
           array.forEach((item) => {
            item.children.forEach((item2) => {
              for(let i=0;i<this.idArray.length;i++){
                let time = "time_"+this.idArray[i]+"yu"
                item2.time = 
              }
            });
          }); */
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped type="text/scss">
@import "../font/iconfont.css";
@import "../css/conmmon.scss";
.ivumodal /deep/ {
  font-family: SimHei;
  color: #7f7f7f;
  .title {
    color: #f59a23;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 15px;
  }
}

.ivu-table .table-warning-row td {
  background-color: #2db7f5;
  color: #fff;
}
.planForm .ivu-form-item {
  margin-bottom: 24px;
}
.planForm .planFormInput {
  width: 220px;
}
.planFormInputAppend {
  color: #ff0000;
}
.yuliang {
  color: #ff0000;
}
.renwu {
  font-family: SimHei;
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .title-btn {
    vertical-align: top;
    float: right;
    margin-left: 10px;
  }
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin-top: 35px;
    margin-bottom: 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/yuyue/jihua.vue